
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const CLEAR_CUSTOMER = 'CLEAR_CUSTOMER';
export const REMOVE_CUSTOMER = 'REMOVE_CUSTOMER';
export const ORDER_CUSTOMER_STORAGE ='AnalogicOrderCustomer';
